<template>
  <DxScrollView :use-native="true" class="reception_tabs">
    <div class="reception_input_holder" v-show="showCodeForProduct" :class="[{ input_holder_error: $v.productData.code.$error }]">
      <div class="input_label">{{ $t("stock_mobile.form.internal_product_code") }}</div>
      <div class="input_value">
        <DxTextBox v-model="productData.code" :placeholder="$t('stock_mobile.form.enter_internal_product_code')" class="global_dx_textbox" />
      </div>
    </div>
    <div
      class="reception_input_holder"
      v-show="showMeasureUnitForProduct"
      :class="[{ input_holder_error: $v.productData.measure_unit_id.$error }]"
    >
      <div class="input_label">{{ $t("common.measure_unit") }}</div>
      <div class="input_value">
        <DxSelectBox
          v-model="productData.measure_unit_id"
          :search-enabled="true"
          search-mode="contains"
          search-expr="name"
          class="input_value dx_input_value"
          :placeholder="$t('stock_mobile.form.select_measure_unit')"
          :data-source="filteredMeasureUnits"
          display-expr="name"
          value-expr="id"
          :show-clear-button="false"
          drop-down-button-template="imageIcon"
          @selection-changed="muChanged"
        >
          <template #imageIcon>
            <div>
              <div class="dx_combo_open_button" v-show="!productData.measure_unit_id || productData.measure_unit_id == ''">
                <img src="@/assets/images/icons/plus_green.svg" class="custom-selector-icon" />
              </div>
              <div class="dx_combo_open_button" v-show="productData.measure_unit_id && productData.measure_unit_id != ''">
                <img src="@/assets/images/icons/edit.svg" class="custom-selector-icon" />
              </div>
            </div>
          </template>
          <template #item="{ data }">
            <div class="dx_custom_combo_item">{{ data.name }}</div>
          </template>
        </DxSelectBox>
      </div>
    </div>
    <div
      class="reception_input_holder"
      v-show="showProductTypeForProduct"
      :class="[
        {
          input_holder_error: $v.productData.product_type_uuid.$error,
        },
      ]"
    >
      <div class="input_label">{{ $t("stock_mobile.form.product_type") }}</div>
      <div class="input_value">
        <DxSelectBox
          v-model="productData.product_type_uuid"
          :search-enabled="true"
          search-mode="contains"
          search-expr="name"
          class="input_value dx_input_value"
          :placeholder="$t('stock_mobile.form.select_product_type')"
          :data-source="productTypes"
          display-expr="name"
          value-expr="uuid"
          :show-clear-button="false"
          drop-down-button-template="imageIcon"
          @selection-changed="productTypeChanged"
        >
          <template #imageIcon>
            <div>
              <div class="dx_combo_open_button" v-show="!productData.product_type_uuid || productData.product_type_uuid == ''">
                <img src="@/assets/images/icons/plus_green.svg" class="custom-selector-icon" />
              </div>
              <div class="dx_combo_open_button" v-show="productData.product_type_uuid && productData.product_type_uuid != ''">
                <img src="@/assets/images/icons/edit.svg" class="custom-selector-icon" />
              </div>
            </div>
          </template>
          <template #item="{ data }">
            <div class="dx_custom_combo_item">{{ data.name }}</div>
          </template>
        </DxSelectBox>
      </div>
    </div>
    <div class="reception_input_holder" v-show="showMeasureUnitForProduct">
      <div class="input_label">{{ $t("stock_mobile.form.base_product") }}</div>
      <div class="input_value" @click="fitoFertilitySelectClick">
        <DxTextBox v-model="productData.fito_fertility_product_name" :placeholder="$t('stock_mobile.form.select_base_product')" class="global_dx_textbox" />
        <div class="dx_combo_open_button">
          <img src="@/assets/images/icons/edit.svg" class="custom-selector-icon" />
        </div>
      </div>
    </div>
    <div class="reception_input_holder" :class="[{ input_holder_error: $v.productData.warehouse_uuid.$error }]" v-show="selectFromStock">
      <div class="input_label">{{ $t("common.warehouse") }}</div>
      <div class="input_value">
        <DxSelectBox
          v-model="productData.warehouse_uuid"
          :search-enabled="true"
          search-mode="contains"
          search-expr="name"
          class="input_value dx_input_value"
          :placeholder="$t('stock_mobile.form.select_warehouse')"
          :data-source="getStockWarehouseList()"
          :display-expr="
            selectFromStock
              ? (item) => `${item?.name || $t('stock_mobile.form.select_sender_warehouse')} (${getFormattedStockQuantity(item?.quantity)} ${
                  productData?.measure_unit?.symbol ?? ''
                })`
              : 'name'
          "
          value-expr="uuid"
          :show-clear-button="false"
          drop-down-button-template="imageIcon"
          @selection-changed="warehouseChanged"
        >
          <template #imageIcon>
            <div>
              <div class="dx_combo_open_button" v-show="!productData.warehouse_uuid">
                <img src="@/assets/images/icons/plus_green.svg" class="custom-selector-icon" />
              </div>
              <div class="dx_combo_open_button" v-show="productData.warehouse_uuid">
                <img src="@/assets/images/icons/edit.svg" class="custom-selector-icon" />
              </div>
            </div>
          </template>
          <template #item="{ data }">
            <div class="dx_custom_combo_item">
              {{ data?.name }} ({{ data.quantity | getFormattedQuantity }} {{ productData?.measure_unit?.symbol }})
            </div>
          </template>
        </DxSelectBox>
      </div>
    </div>
    <div
      class="reception_input_holder"
      v-if="requireDestWarehouse"
      :class="[{ input_holder_error: $v.productData.dest_warehouse_uuid.$error }]"
    >
      <div class="input_label">{{ $t("stock_mobile.form.receiver_warehouse") }}</div>
      <div class="input_value">
        <DxSelectBox
          v-model="productData.dest_warehouse_uuid"
          :search-enabled="true"
          search-mode="contains"
          search-expr="name"
          class="input_value dx_input_value"
          :placeholder="$t('stock_mobile.form.select_receiver_warehouse')"
          :data-source="filteredDestWarehouses"
          :display-expr="warehouseDisplayExpr"
          value-expr="uuid"
          :show-clear-button="false"
          drop-down-button-template="imageIcon"
          @selection-changed="destWarehouseChanged"
        >
          <template #imageIcon>
            <div>
              <div class="dx_combo_open_button" v-show="!productData.dest_warehouse_uuid">
                <img src="@/assets/images/icons/plus_green.svg" class="custom-selector-icon" />
              </div>
              <div class="dx_combo_open_button" v-show="productData.dest_warehouse_uuid">
                <img src="@/assets/images/icons/edit.svg" class="custom-selector-icon" />
              </div>
            </div>
          </template>
          <template #item="{ data }">
            <div class="dx_custom_combo_item">
              {{ data?.name }}{{ data?.department?.name ? ' (' + data.department.name + ')' : '' }}
            </div>
          </template>
        </DxSelectBox>
      </div>
    </div>
    <div class="reception_input_holder" v-if="totalArea > 0">
      <div class="input_label">{{ $t("common.dose") }}</div>
      <div class="input_value">
        <DxNumberBox
          :placeholder="$t('stock_mobile.form.enter_dose')"
          :min="0"
          :format="quantityFormatter + ' ' + (productData?.measure_unit?.symbol ?? '') + '/ha'"
          v-model="productData.dose"
          value-change-event="keyup"
          class="global_dx_number_input"
          :show-clear-button="false"
          @value-changed="doseChanged($event)"
        />
      </div>
      <div class="consum_tabs" v-if="selectFromStock && totalArea > 0">
        <div v-show="selectFromStock" class="consum_input_second_value">{{ parseFloat(parseFloat(totalArea ?? 0).toFixed(4)) }} ha</div>
      </div>
    </div>
    <div class="reception_input_holder" :class="[{ input_holder_error: $v.productData.quantity.$error }]">
      <div class="input_label">{{ $t("common.quantity") }}</div>
      <div class="input_value">
        <DxNumberBox
          :placeholder="$t('stock_mobile.form.enter_quantity')"
          :min="0"
          :format="quantityFormatter + ' ' + (productData?.measure_unit?.symbol ?? '')"
          v-model="productData.quantity"
          value-change-event="keyup"
          class="global_dx_number_input"
          :show-clear-button="false"
          @value-changed="quantityChanged($event)"
        />
      </div>
      <div class="consum_tabs">
        <div v-show="selectFromStock" class="consum_input_second_value">
          {{ $t("stock_mobile.form.product_cost") }}: {{ parseFloat(parseFloat(stockUnitPrice * (productData.quantity ?? 0)).toFixed(2)) }} RON
        </div>
      </div>
    </div>
    <div v-if="isLotManaged" class="reception_input_holder" @click="openLotEditor">
      <div class="lot-items-summary-header">
        <div class="lot-items-summary-title">{{ $t("lot_items.title") }}</div>
        <div class="reception_parcel_edit_icon">
          <i class="fa-regular fa-edit"></i>
        </div>
      </div>
      <div class="lot-items-summary-text" :key="`lot-summary-${lotSummaryKey}`">
        {{ lotItemsSummaryText }}
      </div>
      <div v-if="lotItemsHasError" class="lot-items-summary-error" :key="`lot-error-${lotSummaryKey}`">
        {{ lotItemsErrorMessage }}
      </div>
    </div>
    <div
      class="reception_input_holder"
      :class="[{ input_holder_error: $v.productData.unit_price.$error }]"
      v-if="!selectFromStock && useUnitPrice"
    >
      <div class="input_label">{{ $t("stock_mobile.form.net_unit_price") }}</div>
      <div class="input_value">
        <DxNumberBox
          :min="0"
          :placeholder="$t('stock_mobile.form.enter_net_unit_price')"
          format="#,##0.00 RON"
          v-model="productData.unit_price"
          class="global_dx_number_input"
          :show-clear-button="false"
        />
      </div>
    </div>
    <div class="reception_input_holder">
      <div class="input_label">{{ $t("common.notes") }}</div>
      <div class="input_value">
        <DxTextArea v-model="productData.notes" class="global_dx_number_input" />
      </div>
    </div>
    <div style="margin-bottom: 50px; margin-top: 25px" class="sticky_action_button" @click="applyProductData">{{ $t("common.continue") }}</div>
    <toast-message ref="toastMessageProductData"></toast-message>
    <FitoFertilityProductSelector
      ref="fitoFertilityProductSelector"
      v-if="showProductSelectDialog"
      :visible="showProductSelectDialog"
      @close="showProductSelectDialog = false"
      @continue="onContinueFromProductSelector"
      :multiselect="false"
    />
    <LotItemsEditorPopup
      :visible.sync="lotEditorVisible"
      :value="productData.lot_items"
      :target-quantity="productData.quantity"
      :measure-unit-symbol="productData?.measure_unit?.symbol ?? ''"
      @save="applyLotEditor"
    />
    <LotItemsSelectorPopup
      :visible.sync="lotSelectorVisible"
      :product-uuid="productData.uuid"
      :warehouse-uuid="productData.warehouse_uuid"
      :movement-date="movementDate"
      :target-quantity="productData.quantity"
      :measure-unit-symbol="productData?.measure_unit?.symbol ?? ''"
      :product-name="productData.name"
      :transaction-type="transactionType"
      @save="applyLotSelection"
    />
  </DxScrollView>
</template>

<script>
import { mapActions } from "vuex";
import { DxScrollView } from "devextreme-vue/scroll-view";
import { required, helpers } from "vuelidate/src/validators";
import DxNumberBox from "devextreme-vue/number-box";
import DxTextBox from "devextreme-vue/text-box";
import DxSelectBox from "devextreme-vue/select-box";
import DxTextArea from "devextreme-vue/text-area";
import { getQuantityFormatter } from "~/helpers/stockHelper";
import ToastMessage from "@/components/Mobile/toastMessage.vue";
import { getFormattedQuantity } from "~/helpers/stockHelper";
import FitoFertilityProductSelector from "@/components/Mobile/FitoFertilityProductSelectorMobile.vue";
import LotItemsEditorPopup from "@/components/Mobile/LotItemsEditorPopup.vue";
import LotItemsSelectorPopup from "@/components/Mobile/LotItemsSelectorPopup.vue";

const greaterThanZero = (value) => {
  return helpers.req(value) && value > 0;
};

const greaterOrEqualsThanZero = (param) => (value) => {
  if (param) {
    return helpers.req(value) && value >= 0;
  }
  return true;
};

const requiredByParam = (param) => (value) => {
  if (param) {
    return helpers.req(value) && value.length > 0;
  }
  return true;
};

const requiredByParamGreaterThanZero = (param) => (value) => {
  if (param) {
    return helpers.req(value) && value > 0;
  }
  return true;
};

const requiredByParamAvaliableQuantity = (param) => (value) => {
  return helpers.req(value) && value <= param && value > 0;
};

const lotItemsRequired = (vm) => (value) => {
  if (!vm.isLotManaged) {
    return true;
  }
  return Array.isArray(value) && value.length > 0;
};

const lotItemsSumMatches = (vm) => (value) => {
  if (!vm.isLotManaged) {
    return true;
  }
  const items = Array.isArray(value) ? value : [];
  const sum = items.reduce((acc, item) => acc + (parseFloat(item.quantity) || 0), 0);
  const qty = parseFloat(vm.productData?.quantity) || 0;
  return Math.abs(sum - qty) <= 0.0001 && qty > 0;
};

export default {
  name: "ProductData",
  props: {
    selectedProductList: {
      type: Array,
      default: () => [],
    },
    selectedProduct: {
      type: Object,
      default: () => null,
    },
    selectFromStock: {
      type: Boolean,
      default: false,
    },
    multipleSelection: {
      type: Boolean,
      default: true,
    },
    useUnitPrice: {
      type: Boolean,
      default: true,
    },
    totalArea: {
      type: Number,
      default: 0,
    },
    movementDate: {
      type: String,
      default: "",
    },
    transactionType: {
      type: String,
      default: "",
    },
    filterData: {
      type: Object,
      default: null,
    },
    destWarehouses: {
      type: Array,
      default: () => [],
    },
    requireDestWarehouse: {
      type: Boolean,
      default: false,
    },
    allowStockMovementOnlyInLegalEntity: {
      type: Boolean,
      default: false,
    },
    requiredLotForLotManagedProducts: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      productData: this.selectedProduct ?? {
        uuid: "",
        name: "",
        code: "",
        quantity: 0,
        unit_price: 0,
        notes: "",
        measure_unit_id: null,
        measure_unit: null,
        product_type_uuid: null,
        product_type: null,
        warehouse_uuid: null,
        warehouse_name: null,
        department_name: null,
        dest_warehouse_uuid: null,
        dest_warehouse_name: null,
        dest_department_name: null,
        warehouse_quantity: 0,
        stock_list: [],
        lot_management: false,
        lot_items: [],
      },
      showMeasureUnitForProduct: this.shouldShowMeasureUnit(this.selectedProduct),
      showProductTypeForProduct: this.selectedProduct?.uuid?.toString()?.startsWith("NEW_") ?? false,
      showCodeForProduct: this.selectedProduct?.uuid?.toString()?.startsWith("NEW_") ?? false,
      use_default_0_unit_price_on_reception: false,
      measureUnits: [],
      productTypes: [],
      quantityChangeTimer: null, // Timer for debounce
      stockUnitPrice: 0,
      quantityDoseCalculationRunning: false,
      showProductSelectDialog: false,
      lotEditorVisible: false,
      lotSelectorVisible: false,
      lotSummaryKey: 0,
      // new guards
      calcLock: false, // prevent quantity↔dose loop
      priceReqSeq: 0, // drop stale price responses
      isDestroyed: false, // guard async after unmount
    };
  },
  components: {
    DxScrollView,
    DxSelectBox,
    DxTextArea,
    DxNumberBox,
    DxTextBox,
    ToastMessage,
    FitoFertilityProductSelector,
    LotItemsEditorPopup,
    LotItemsSelectorPopup,
  },
  validations() {
    return {
      productData: {
        uuid: { required },
        measure_unit_id: {
          requiredByParam: requiredByParamGreaterThanZero(this.showMeasureUnitForProduct),
        },
        product_type_uuid: {
          requiredByParam: requiredByParam(this.showProductTypeForProduct),
        },
        code: { requiredByParam: requiredByParam(false) },
        quantity: {
          requiredByParam: this.selectFromStock
            ? requiredByParamAvaliableQuantity(this.productData?.warehouse_quantity ?? 0)
            : greaterThanZero,
        },
        unit_price: { requiredByParam: greaterOrEqualsThanZero(!this.selectFromStock) },
        warehouse_uuid: { requiredByParam: requiredByParam(this.selectFromStock) },
        dest_warehouse_uuid: { requiredByParam: requiredByParam(this.requireDestWarehouse) },
        lot_items: {
          lotItemsRequired: lotItemsRequired(this),
          lotItemsSumMatches: lotItemsSumMatches(this),
        },
      },
    };
  },
  computed: {
        filteredMeasureUnits() {
          const groupId = this.filterData?.measure_unit_group_id ?? null;
          if (!groupId) {
            return this.measureUnits;
          }

          const matchesGroup = (unit) => {
            const unitGroupId = unit?.measure_unit_group_id ?? unit?.measure_unit_group?.id ?? unit?.group_id ?? null;
            return unitGroupId === groupId;
          };

          const filtered = (this.measureUnits || []).filter(matchesGroup);
          const selectedId = this.productData?.measure_unit_id ?? null;
          if (selectedId && !filtered.some((unit) => unit.id === selectedId)) {
            const selectedUnit = (this.measureUnits || []).find((unit) => unit.id === selectedId);
            if (selectedUnit) {
              filtered.push(selectedUnit);
            }
          }

          return filtered;
        },
    quantityFormatter() {
      return getQuantityFormatter();
    },
    isLotManaged() {
      return !!this.productData?.lot_management && this.requiredLotForLotManagedProducts;
    },
    lotItemsCount() {
      return Array.isArray(this.productData?.lot_items) ? this.productData.lot_items.length : 0;
    },
    lotItemsTotal() {
      const items = Array.isArray(this.productData?.lot_items) ? this.productData.lot_items : [];
      const total = items.reduce((acc, item) => acc + (parseFloat(item.quantity) || 0), 0);
      return parseFloat(total.toFixed(4));
    },
    lotItemsSummaryText() {
      return this.$t("lot_items.summary", {
        count: this.lotItemsCount,
        total: this.lotItemsTotal,
        unit: this.productData?.measure_unit?.symbol ?? "",
      });
    },
    lotItemsHasError() {
      return !!this.getLotItemsError(this.productData?.lot_items);
    },
    lotItemsErrorMessage() {
      return this.getLotItemsError(this.productData?.lot_items) || "";
    },
    filteredDestWarehouses() {
      if (!this.requireDestWarehouse) {
        return [];
      }
      const sourceUuid = this.productData?.warehouse_uuid ?? null;
      const sourceLegalEntity = this.productData?.warehouse_department_legal_entity_uuid ?? null;

      return (this.destWarehouses || []).filter((wh) => {
        if (sourceUuid && wh.uuid === sourceUuid) {
          return false;
        }
        if (this.allowStockMovementOnlyInLegalEntity && sourceLegalEntity) {
          return wh.legal_entity_uuid === sourceLegalEntity;
        }
        return true;
      });
    },
  },
  watch: {
    selectedProduct: function (newVal) {
      this.setProduct(newVal);
    },
  },
  methods: {
    warehouseDisplayExpr(item) {
      if (!item) return '';
      return item.department?.name ? `${item.name} (${item.department.name})` : item.name;
    },
    ...mapActions({
      getProductTypes: "smProductTypes/searchSmProductTypes",
      getMeasureUnits: "measureUnits/getMeasureUnits",
      getGroupByCode: "settings/getGroupByCode",
      getStockProductInfo: "smStocks/getSmStockProductInfo",
    }),
    shouldShowMeasureUnit(product) {
      const uuid = product?.uuid?.toString() ?? "";
      return uuid.startsWith("NEW_") || !product?.measure_unit_id;
    },
    ensureMeasureUnitFromId() {
      if (this.productData?.measure_unit || !this.productData?.measure_unit_id) {
        return;
      }
      const unit = (this.measureUnits || []).find((item) => item.id === this.productData.measure_unit_id);
      if (unit) {
        this.productData.measure_unit = unit;
      }
    },
    setProduct(product) {
      if (!product) {
        return;
      }
      if (product?.uuid === this.productData?.uuid) {
        return;
      }

      this.productData = {
        ...(product || {}),
        lot_items: Array.isArray(product?.lot_items) ? product.lot_items : [],
      };
      const show_new_product_fields = this.productData.uuid.toString().startsWith("NEW_");
      this.showMeasureUnitForProduct = show_new_product_fields || !this.productData?.measure_unit_id;
      this.showProductTypeForProduct = show_new_product_fields;
      this.showCodeForProduct = show_new_product_fields;
      this.ensureMeasureUnitFromId();
      this.stockUnitPrice = 0;
    },
    muChanged(e) {
      if (!this.selectFromStock) {
        if (e.selectedItem) {
          if (e.selectedItem.id !== this.productData.measure_unit_id) {
            this.productData.measure_unit = e.selectedItem;
            this.productData.measure_unit_id = e.selectedItem.id;
          }
        } else {
          if (this.productData.uuid.startsWith("NEW_")) {
            this.productData.measure_unit = null;
            this.productData.measure_unit_id = null;
          }
        }
      }
    },
    productTypeChanged(e) {
      if (!this.selectFromStock) {
        if (e.selectedItem && e.selectedItem.uuid !== this.productData.product_type_uuid) {
          this.productData.product_type_uuid = e.selectedItem.uuid;
          this.productData.product_type = e.selectedItem;
        }
      }
    },
    warehouseChanged(e) {
      if (this.selectFromStock && e.selectedItem) {
        this.productData.warehouse_name = e.selectedItem.name;
        this.productData.department_name = e.selectedItem.department?.name || null;
        this.productData.warehouse_quantity = e.selectedItem.quantity;
        this.productData.warehouse_department_legal_entity_uuid = e.selectedItem.legal_entity_uuid;

        if (e.selectedItem && e.selectedItem.uuid !== this.productData.warehouse_uuid) {
          this.productData.warehouse_uuid = e.selectedItem.uuid;
        }

        if (this.requireDestWarehouse) {
          const destIsValid = this.filteredDestWarehouses.some((wh) => wh.uuid === this.productData.dest_warehouse_uuid);
          if (!destIsValid) {
            this.productData.dest_warehouse_uuid = null;
            this.productData.dest_warehouse_name = null;
          }
        }
      }
    },
    destWarehouseChanged(e) {
      if (e.selectedItem) {
        this.productData.dest_warehouse_uuid = e.selectedItem.uuid;
        this.productData.dest_warehouse_name = e.selectedItem.name;
        this.productData.dest_department_name = e.selectedItem.department?.name || null;
      }
    },
    quantityChanged(e) {
      // Only schedule for user input (DevExtreme sends e.event for user-triggered changes)
      if (!e || !e.event || !this.selectFromStock) return;

      // normalize numeric
      this.productData.quantity = this._toNumber(this.productData.quantity, 0);
      this.$set(this.productData, "quantity", this.productData.quantity);

      // debounced price fetch
      this._scheduleStockPriceLookup();

      // dose = qty / area
      this._updateDoseFromQuantity();
    },
    doseChanged(e) {
      // Only schedule for user input; programmatic updates (from qty) won’t re-trigger
      if (!e || !e.event || !this.selectFromStock) return;

      // normalize numeric
      this.productData.dose = this._toNumber(this.productData.dose, 0);
      this.$set(this.productData, "dose", this.productData.dose);

      // qty = area * dose
      this._updateQuantityFromDose();

      // price may depend on qty
      this._scheduleStockPriceLookup();
    },
    applyProductData() {
      if (!Object.prototype.hasOwnProperty.call(this.productData, "unit_price")) {
        this.$set(this.productData, "unit_price", 0);
      }

      this.$v.$touch();
      if (this.$v.$invalid) {
        // Show error message for invalid fields based on the validation rules
        if (this.showMeasureUnitForProduct && this.$v.productData.measure_unit_id.$invalid) {
          this.$refs.toastMessageProductData.showError(this.$t("measure_unit_required"));
        }
        if (this.showProductTypeForProduct && this.$v.productData.product_type_uuid.$invalid) {
          this.$refs.toastMessageProductData.showError(this.$t("product_type_required"));
        }
        if (this.selectFromStock) {
          if (this.$v.productData.warehouse_uuid.$invalid) {
            this.$refs.toastMessageProductData.showError(this.$t("warehouse_required"));
          } else if (this.$v.productData.quantity.$invalid) {
            this.$refs.toastMessageProductData.showError(
              this.$t("quantity_invalid_stock", {
                max: parseFloat(this.productData?.warehouse_quantity ?? 0).toString(),
              }),
            );
          }
        } else {
          if (this.$v.productData.quantity.$invalid) {
            this.$refs.toastMessageProductData.showError(this.$t("quantity_invalid", { min: 1 }));
          }
          if (this.$v.productData.unit_price.$invalid) {
            this.$refs.toastMessageProductData.showError(this.$t("unit_price_invalid", { min: 0 }));
          }
        }

        if (this.requireDestWarehouse && this.$v.productData.dest_warehouse_uuid.$invalid) {
          this.$refs.toastMessageProductData.showError(this.$t("dest_warehouse_required"));
        }
        if (this.isLotManaged && this.$v.productData.lot_items.$invalid) {
          this.$refs.toastMessageProductData.showError(this.lotItemsErrorMessage);
        }

        return;
      }

      this.ensureMeasureUnitFromId();

      const existingProduct = this.selectedProductList.find((product) => product.uuid === this.productData.uuid);

      if (this.multipleSelection) {
        if (!existingProduct) {
          this.selectedProductList.push({ ...this.productData, expanded: true });
        } else {
          const existingProductIndex = this.selectedProductList.indexOf(existingProduct);
          this.$set(this.selectedProductList, existingProductIndex, {
            ...existingProduct,
            ...this.productData,
            expanded: existingProduct.expanded !== false,
          });
        }
        this.$emit("goForward");
      } else {
        if (!existingProduct) {
          if (this.selectedProductList.length > 0) {
            this.selectedProductList[0] = this.productData;
          } else {
            this.selectedProductList.push(this.productData);
          }
        }
        this.$emit("closeProductSelector");
      }
    },
    getStockWarehouseList() {
      if (!this.selectFromStock) {
        return [];
      }
      return (
        this.productData.stock_list?.map((stock) => ({
          uuid: stock.warehouse_uuid,
          name: stock.warehouse_name,
          quantity: stock.quantity,
          legal_entity_uuid: stock.legal_entity_uuid,
        })) || []
      );
    },
    getFormattedStockQuantity(quantity) {
      if (quantity === null || quantity === undefined) {
        return 0;
      }
      if (quantity > 0) {
        return getFormattedQuantity(quantity);
      }
      return 0;
    },
    onContinueFromProductSelector(selectedProducts) {
      this.showProductSelectDialog = false; // Hide the ProductSelector dialog
      if (selectedProducts && selectedProducts.length > 0) {
        this.productData.fito_fertility_product_name = selectedProducts[0].name;
        this.productData.fito_fertility_product_uuid = selectedProducts[0].uuid;
      }
    },
    fitoFertilitySelectClick() {
      this.showProductSelectDialog = true; // Show the ProductSelector dialog
    },
    openLotEditor() {
      if (this.selectFromStock) {
        this.openLotSelector();
        return;
      }
      this.lotEditorVisible = true;
    },
    openLotSelector() {
      if (!this.productData?.uuid || !this.productData?.warehouse_uuid || !this.movementDate) {
        this.$refs.toastMessageProductData.showError(this.$t("stock_mobile.form.error_select_product_warehouse_date_before_lots"));
        return;
      }
      this.lotSelectorVisible = true;
    },
    applyLotEditor(items) {
      const nextItems = Array.isArray(items) ? items : [];
      this.productData = {
        ...this.productData,
        lot_items: nextItems,
      };
      this.lotEditorVisible = false;
      this.lotSummaryKey += 1;
    },
    applyLotSelection(items) {
      const nextItems = Array.isArray(items) ? items : [];
      this.productData = {
        ...this.productData,
        lot_items: nextItems,
      };
      this.lotSelectorVisible = false;
      this.lotSummaryKey += 1;
    },
    getLotItemsError(items) {
      if (!this.isLotManaged) {
        return "";
      }
      if (!Array.isArray(items) || items.length === 0) {
        return this.$t("lot_items.required");
      }
      const sum = items.reduce((acc, item) => acc + (parseFloat(item.quantity) || 0), 0);
      const qty = parseFloat(this.productData?.quantity) || 0;
      if (Math.abs(sum - qty) > 0.0001 || qty <= 0 || items.some((item) => (parseFloat(item.quantity) || 0) <= 0) || sum <= 0) {
        return this.$t("lot_items.sum_mismatch");
      }
      return "";
    },
    _toNumber(v, def = 0) {
      const n = typeof v === "number" ? v : parseFloat(v);
      return Number.isFinite(n) ? n : def;
    },
    _round(n, decimals = 4) {
      const f = Math.pow(10, decimals);
      return Math.round(this._toNumber(n) * f) / f;
    },
    async _scheduleStockPriceLookup() {
      if (!this.selectFromStock) return;

      clearTimeout(this.quantityChangeTimer);
      this.quantityChangeTimer = setTimeout(async () => {
        const qty = this._toNumber(this.productData.quantity);
        const wh = this.productData.warehouse_uuid;
        const product = this.productData.uuid;

        if (!wh || !product || qty <= 0) {
          this.stockUnitPrice = 0;
          this.$set(this, "stockUnitPrice", 0);
          return;
        }

        const seq = ++this.priceReqSeq;
        try {
          const payload = { product_uuid: product, warehouse_uuid: wh, quantity: qty };
          const resp = await this.getStockProductInfo(payload);
          if (this.isDestroyed || seq !== this.priceReqSeq) return;

          const price = this._toNumber(resp?.price_net, 0);
          this.stockUnitPrice = price;
          this.$set(this, "stockUnitPrice", price);
        } catch (e) {
          if (this.isDestroyed) return;
          this.stockUnitPrice = 0;
          this.$set(this, "stockUnitPrice", 0);
        }
      }, 900);
    },
    _updateDoseFromQuantity() {
      if (this.calcLock) return;
      const qty = this._toNumber(this.productData.quantity);
      const area = this._toNumber(this.totalArea);
      let dose = 0;
      if (!this.selectFromStock || qty <= 0 || area <= 0) {
        dose = 0;
      } else {
        dose = this._round(qty / area, 4);
      }

      this.calcLock = true;
      this.productData.dose = dose;
      this.$set(this.productData, "dose", dose);
      this.calcLock = false;
    },
    _updateQuantityFromDose() {
      if (this.calcLock) return;
      const dose = this._toNumber(this.productData.dose);
      const area = this._toNumber(this.totalArea);
      let qty = 0;
      if (!this.selectFromStock || dose <= 0 || area <= 0) {
        qty = 0;
      } else {
        qty = this._round(area * dose, 4);
      }

      this.calcLock = true;
      this.productData.quantity = qty;
      this.$set(this.productData, "quantity", qty);
      this.calcLock = false;
    },
  },
  beforeDestroy() {
    this.isDestroyed = true;
    clearTimeout(this.quantityChangeTimer);
  },
  mounted() {
    // Get the product types and measure units for the product if not select from stock
    if (!this.selectFromStock) {
      this.getGroupByCode({
        code: "STOCK_MANAGEMENT",
      }).then((response) => {
        this.use_default_0_unit_price_on_reception =
          response.items.find((obj) => obj.code == "USE_DEFAULT_0_UNIT_PRICE_ON_RECEPTION")?.value == "1";
        if (this.use_default_0_unit_price_on_reception && !(this.productData.unit_price > 0)) {
          this.productData.unit_price = 0;
        }
      });

      this.getMeasureUnits().then((response) => {
        this.measureUnits = response.data;
        this.ensureMeasureUnitFromId();
      });
      this.getProductTypes({}).then((response) => {
        this.productTypes = response;
      });
    }
    //-----------------------------------------------------------------------------------
  },
};
</script>

<style scoped>
.lot-items-summary-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 6px;
}

.lot-items-summary-title {
  font-weight: 700;
  font-size: 14px;
}

.lot-items-summary-text {
  font-size: 12px;
  color: #4a4a4a;
}

.lot-items-summary-error {
  margin-top: 6px;
  color: #dc3545;
  font-size: 12px;
}
</style>
